<template>
    <div 
    class="add-airport-input dropdown"
    @focus="handleFocus"
    v-click-outside="handleFocusOut"
    @keydown.esc="handleFocusOut"
    tabindex="0">
        <!-- Search icon -->
        <i class="far fa-search" v-if="! isLoading"></i>

        <!-- Loading icon -->
        <i class="fa fa-spinner-third fa-spin" v-if="isLoading"></i>

        <!-- Clear icon -->
        <i class="fa fas fa-times-circle" @click="clearInput" v-if="query.trim().length > 0"></i>

        <!-- Airport query -->
        <input
        type="text"
        class="blank-control"
        v-model="query"
        :placeholder="'components.addAirportInput.placeholder' | trans"
        @focus="handleFocus"
        @blur="handleBlur"
        autocomplete="off"
        ref="airportQueryInput" />

        <div class="dropdown-menu show w-100 py-0 overflow-hidden" v-show="dropdownVisible">
            <!-- Airport item -->
            <a class="dropdown-item airport-item"
            href="#"
            v-for="(airport, index) in airports"
            :key="'airport_' + index"
            @click.prevent="selectAirport(airport)">
                <span class="iata-code">
                    {{ airport.iata_airport_code }}
                </span>

                <span class="info">
                    <span class="name">
                        {{ airport.name }}
                    </span>

                    <small class="shortname">
                        {{ airport.shortname_cropped }}
                    </small>
                </span>
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['tripId', 'exclusions'],
        data() {
            return {
                query: '',
                isLoading: false,
                airports: [],
                cancelSource: null,
                isFocus: false,
                showDropdown: false,
            }
        },
        mounted() {},
        computed: {
            dropdownVisible() {
                return this.airports && this.airports.length > 0 && this.showDropdown && this.value !== null && String(this.value).length > 0
            },
        },
        methods: {
            handleFocus() {
                this.isFocus = true
                this.resetInput()
            },
            handleBlur() {
                this.isFocus = false
            },
            clearInput() {
                this.query = ''
                this.airports = []
                this.hideDropdown()
            },
            updateValue(event) {
                this.$emit('input', event.target.value)

                if ((! this.location || (this.location && event.target.value !== this.location.name)) && event.target.value.length > 0) {
                    this.search(event.target.value)
                }
            },
            resetInput() {
                this.$emit('input', '')
            },
            selectAirport(item) {
                this.$emit('addAirport', item)
                this.query = ''
                this.airports = []
                this.hideDropdown()
            },
            search() {
                var self = this;

                if (this.query.length === 0) {
                    return;
                }

                // Cancel previous search
                if (this.cancelSource !== null) {
                    this.cancelSource.cancel()
                }

                // Create cancel token
                const CancelToken = axios.CancelToken
                this.cancelSource = CancelToken.source()

                this.isLoading = true

                // Exclusions
                const exclusions = typeof (this.exclusions) !== 'undefined' ? this.exclusions : []

                axios.get(route('api.checkout.searchAirports'), {
                    params: {
                        trip_id: this.tripId,
                        type: 'origin',
                        query: this.query,
                        exclusions: exclusions
                    },
                    cancelToken: this.cancelSource.token,
                }).then(function (response) {
                    self.airports = response.data.data
                    self.showDropdown = true
                    self.isLoading = false
                }).catch(function (error) {
                    self.isLoading = false
                });
            },
            toggleDropdown() {
                this.showDropdown = ! this.showDropdown
            },
            hideDropdown() {
                this.showDropdown = false
            },
            focus() {
                if (this.$refs.airportQueryInput) {
                    this.$refs.airportQueryInput.focus()
                }
            },

            handleFocus() {
                console.log('focus')
                if (this.airports.length > 0) {
                    this.showDropdown = true
                }
            },
            handleFocusOut() {
                console.log('lost focus')
                this.hideDropdown()
            },
        },
        watch: {
            query() {
                this.search()

                if (this.query.trim().length === 0) {
                    this.airports = []
                }
            },
        },
        directives: {
            clickOutside: {
                bind: function (el, binding, vnode) {
                    el.clickOutsideEvent = function (event) {
                    // here I check that click was outside the el and his children
                    if (!(el == event.target || el.contains(event.target))) {
                        // and if it did, call method provided in attribute value
                        vnode.context[binding.expression](event);
                    }
                    };
                    document.body.addEventListener('click', el.clickOutsideEvent)
                },

                unbind: function (el) {
                    document.body.removeEventListener('click', el.clickOutsideEvent)
                },
            },
        }
    }
</script>